import './css/app.css';
import 'utils/lazysizes';
import { picoapp } from 'picoapp';

import 'vendors/trustpilot';
import 'lib/tracking';
import Zendesk from 'vendors/zendesk';
import Klaviyo from 'vendors/klaviyo';

import Header from 'layout/header';
import Navigation from 'layout/navigation';
import Footer from 'layout/footer';
import Hero from 'layout/hero';

import LanguageSwitcher from 'layout/language-switcher';
import GeoLocation from 'layout/geolocation';

import SearchDrawer from 'layout/search-drawer';
import QuickSearch from 'layout/quick-search';

import ProductKlaviyo from 'layout/product-klaviyo';
import ProductItem from 'layout/product-item';
import ProductSlider from 'layout/product-slider';
import SizeAssistant from 'layout/size-assistant';
import ProductSizeguide from 'layout/product-sizeguide';
import LinkedProducts from 'layout/linked-products';

import WishlistShare from 'layout/wishlist-share';
import WishlistForm from 'layout/wishlist-form';

import CartDrawer from 'layout/cart-drawer';
import CartItem from 'layout/cart-item';
import CartItemEdit from 'layout/cart-item-edit';
import Quantity from 'lib/quantity';
import CartFaq from 'lib/cart-faq';
import CartTerms from 'layout/cart-terms';

import CartRecommendations from 'layout/cart-recommendations';
import CartRecommendationItem from 'layout/cart-recommendation-item';
import BlackfridayPassword from 'layout/blackfriday-password';
import Banner from 'layout/banner';

import lazyloadVideo from 'components/lazyload-video';

const app = picoapp({
  Zendesk,
  Klaviyo,

  Header,
  Navigation,
  Footer,
  Hero,

  LanguageSwitcher,
  GeoLocation,

  SearchDrawer,
  QuickSearch,

  ProductKlaviyo,
  ProductItem,
  ProductSlider,
  SizeAssistant,
  ProductSizeguide,
  LinkedProducts,

  WishlistShare,
  WishlistForm,

  CartDrawer,
  CartItem,
  CartItemEdit,
  Quantity,
  CartFaq,
  CartTerms,

  CartRecommendations,
  CartRecommendationItem,
  'blackfriday-password': BlackfridayPassword,
  Banner,

  lazyloadVideo,
}, {
  cart: theme.cart,
});

app.mount();

document.addEventListener('app:mount', () => app.mount());
document.addEventListener('shopify:section:load', () => app.mount());

export default app;
